module.exports = __webpack_public_path__ + "static/media/RN-2025-04_preview.beaf06ba.jpg";